export default __webpack_public_path__ + "static/media/company.f70947e4.svg";